// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 743 ? "fc09faed" : chunkId) + "." + {"743":"32058584751e7c36","910":"fed10aec59487b6c"}[chunkId] + ".js";
};